import { Component, OnInit, ChangeDetectionStrategy, Inject, Input, EventEmitter, Output, OnChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { LgvAPIService, LgvClientService, LgvSnapshotHelper, LgvUserService } from '../../core/core.module';
import { BehaviorSubject, Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';
import { LgvAuthMgrService } from '../../core/services/lgv-auth-mgr.service';
import { LgvModel } from '../../data-models/longevity.model';
import { EmailPopup } from '../email-popup/email-popup.component';


@Component({
    selector: 'lgv-agent-footer',
    templateUrl: 'agent-footer.component.html',
    styleUrls: ['./agent-footer.component.scss']
})

export class AgentFooter implements OnInit {

    _CoBrandingState: string = 'None';
    CoBrandingState$ = new BehaviorSubject(this._CoBrandingState);


    RealtorCoBrandingDTO$: Observable<LgvModel.AgentDTO>;

    constructor(public LgvClientSvc: LgvClientService, public LgvUserSvc: LgvUserService, public authMgr: LgvAuthMgrService, public dialog: MatDialog)
    {
    }

    ngOnInit() {


        this.LgvUserSvc.IsCoBranding$.pipe(first(f => f !== null)).subscribe(isCB => {
            if (isCB) {
                this.CoBrandingState$.next('CoBranded');
            }
        });

        if (!this.authMgr.IsClient) {

            this.LgvUserSvc.AgentSS$.pipe(first(f => f !== null)).subscribe(agentSS => {

                this.LgvClientSvc.SnapShot$.pipe(first(x => x !== null)).subscribe(clientSS => {
                    if (clientSS.clientInfo.ownerId !== agentSS.agentInfo.id) {

                        this.CoBrandingState$.next('ForceRealtor');

                        let searchID = clientSS.clientInfo.ownerId;
                        //console.log('searchID: ' + searchID);

                        if (searchID) {

                            this.RealtorCoBrandingDTO$ = this.LgvUserSvc.FetchCoBrandingDTOAgentFromCache(searchID);

                        }


                    }
                });

            });

        }
    }

    OnSendEmail(): void {
        const dialogRef = this.dialog.open(EmailPopup, {
            width: '500px',
            data: { type: 'General' }
        });
    }

}
